import * as actions from './actions';


export default (state = {}, action) => {
  switch (action.type) {
    case actions.OPEN.END:
      return {
        ...state,
        sprint: action.sprint,
      };    
    case actions.LOAD.END:
      return {
        ...state,
        sprint: action.sprint,
      };
    case actions.SAVE.END:
      return {
        ...state,
        sprint: action.sprint,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/sprint/editor/reducer.js